<span class="bb-badge-counter">
  @if (countValue) {
    <span class="badge badge-counter" [ngClass]="[color ? 'badge-counter-' + color : '']">
      {{ countValue }}
    </span>
  }
</span>
